// @ts-nocheck
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, EXPIRE_API } from './apiConfig';

const useStatusConfirm = () => {
  const [isExpired, setIsExpired] = useState(false);
  const [keyParam, setKeyParam] = useState('');
  const [emailParam, setEmailParam] = useState('');
  const [clientMessage, setClientMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const URL = window.location.href;
  const urlParam = new URLSearchParams(URL.split('?')[1]);
  const keyParams = urlParam.get('key');

  useEffect(() => {
    // Parse the dummy URL
    const url = `${API_URL}/daywork-docket/client-signature/?key=${keyParams}`;
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const keyParamValue = urlParams.get('key');

    // Set keyParam and emailParam states
    setKeyParam(keyParamValue || '');

    setLoading(false);
  }, []);

  // LINK EXPIRED
  useEffect(() => {
    const fetchLinkExpireStatus = async () => {
      try {
        const response = await axios.get(
          `${API_URL}${EXPIRE_API}?key=${keyParams}`,
        );
        setIsExpired(response.data.data[0].is_expired);
        setEmailParam(response.data.data[0].client_email);
        setClientMessage(response.data.message);
      } catch (error) {
        console.error('Error fetching link expiration status:', error);
      } finally {
        setLoading(false);
      }
    };

    if (keyParams) {
      fetchLinkExpireStatus();
    }
  }, [keyParams]);

  return {
    isExpired,
    keyParams,
    emailParam,
    keyParam,
    loading,
    clientMessage,
  };
};

export default useStatusConfirm;
